module.exports = __webpack_public_path__ + "static/nosotros-20d045d1c581ac73c85ef1d4922a50e5.mp4";